jQuery(document).ready(function ($) {
    const isMobile = window.innerWidth < 992;
    const $swiperContainer = $('.standout-swiper');
    const totalSlides = $swiperContainer.find('.swiper-slide').not('.ghost-slide').length;

    // Desktop Swiper init
    const desktopSwiper = new Swiper('.standout-swiper', {
        slidesPerView: 1.9,
        spaceBetween: 15,
        loop: false,
        allowTouchMove: true,
        simulateTouch: true,
        centeredSlides: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function () {
                appendGhostSlide(this);
                updatePagination(this);
                updateSlideContent(this.realIndex);
                updateSlideClasses(this);
                adjustNextButton(this); // 🔁 Add listener
            },
            slideChange: function () {
                updatePagination(this);
                updateSlideContent(this.realIndex);
                updateSlideClasses(this);
                adjustNextButton(this);
            }
        }
    });

    function appendGhostSlide(swiper) {
        if ($('.standout-swiper .swiper-slide.ghost-slide').length === 0) {
            const ghostSlide = document.createElement('div');
            ghostSlide.className = 'swiper-slide ghost-slide';
            swiper.wrapperEl.appendChild(ghostSlide);
            swiper.update();
        }
    }

    function adjustNextButton(swiper) {
        const $nextBtn = $('.swiper-button-next');
        const maxIndex = totalSlides - Math.floor(swiper.params.slidesPerView);

        if (swiper.realIndex >= maxIndex) {
            $nextBtn.prop('disabled', true).addClass('swiper-button-disabled');
        } else {
            $nextBtn.prop('disabled', false).removeClass('swiper-button-disabled');
        }
    }

    function updatePagination(swiper) {
        const current = swiper.realIndex + 1;
        $('.custom-pagination .current-slide').text(current);
    }

    function updateSlideContent(index) {
        const $contentBlock = $('#standout-slide-content-data .slide-content-block[data-index="' + index + '"]');
        $('#standout-slide-content').html($contentBlock.html());
    }

    function updateSlideClasses(swiper) {
        $('.swiper-slide').removeClass('manual-active-slide');
        $(swiper.slides[swiper.activeIndex]).addClass('manual-active-slide');
    }

    // ✅ Mobile Swiper
    if (isMobile) {
        new Swiper('.standout-slider-mobile-swiper', {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            allowTouchMove: true,
            simulateTouch: true,
            pagination: {
                el: '.standout-slider-mobile .swiper-pagination',
                type: 'progressbar',
            },
        });
    }
});
